// 使用命名导出
export const getCities = (state) => {
    return state.cityList;
};
